import WebComponent from "../../common/WebComponent";

class VerschenkenFormular extends WebComponent {
  connectedCallback() {
    this.initZustellungToggle();
    this.initBerechnungRestzeichen();
  }

  initBerechnungRestzeichen() {
    const nachrichtenContainer = this.querySelector(".nachricht-container");
    const nachrichtenFeld = nachrichtenContainer.querySelector("textarea");
    const uebrigeZeichenContainer = nachrichtenContainer.querySelector(".verbleibende-zeichen");
    const zeichenUebrig = uebrigeZeichenContainer.querySelector("em");
    nachrichtenFeld.addEventListener("input", () => { setzeUebrigeZeichen(nachrichtenFeld, zeichenUebrig); });
    uebrigeZeichenContainer.classList.remove("hidden");
  }

  initZustellungToggle() {
    const verschenkenRadios = Array.from(this.querySelectorAll(".verschenken-toggle-radio"));
    const empfaengerToggle = this.querySelector(".mail-versenden");
    const inputEmail = this.querySelector("[name=email-input]");
    verschenkenRadios.forEach((radio) => {
      this.addListener(radio, "change", (event) => {
        const { target } = event;
        const radioValue = (target).value;

        empfaengerToggle.dataset.selection = radioValue;
        if (radioValue === "an-mich") {
          inputEmail.removeAttribute("required");
          inputEmail.value = "";
          empfaengerToggle.style.display='none';
        } else {
          inputEmail.setAttribute("required", "required");
          empfaengerToggle.style.display='block';
        }
      });
    });
  }
}

if (!customElements.get("verschenken-formular")) {
  customElements.define("verschenken-formular", VerschenkenFormular);
}

function berechneUebrigeZeichen(textarea) {
  return parseInt(textarea.getAttribute("maxlength"), 10) - textarea.value.length;
}

function setzeUebrigeZeichen(eingabeElement, ausgabeElement) {
  const zeichenUebrig = berechneUebrigeZeichen(eingabeElement);
  // eslint-disable-next-line no-param-reassign
  ausgabeElement.textContent = zeichenUebrig;
}